"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPredicableRelatedInstance = exports.getNamedRelatedInstance = exports.getNamedRelatedObjectId = exports.getNamedApexInstance = exports.getApexNamedObjectId = exports.getApexObjectId = void 0;
const tslib_1 = require("tslib");
const config_1 = tslib_1.__importDefault(require("@iotv/config"));
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const uuid_1 = require("uuid");
const { projectCode } = process.env;
const debug = !process.env.AWS_SESSION_TOKEN && false;
const { app: { namespace_uuid }, } = config_1.default;
/** returns predictable id `Id` for a single apex object of `type`,
 * note: uses full `projectCode`, not substringed to 4 chars - will be same for each environment
 * This is name *independent*, only one object of this type will be present in the system, based on the `sk`, `pk` schema
 */
const getApexObjectId = ({ type }) => {
    const canonicalProjectApexObjectTypeId = `${projectCode}-Apex-${type}`;
    const Id = (0, uuid_1.v5)(canonicalProjectApexObjectTypeId, namespace_uuid);
    debug && console.log(`With namespace_uuid: ${namespace_uuid}, Apex ${type} id:`, Id);
    return Id;
};
exports.getApexObjectId = getApexObjectId;
/** returns predictable id `Id` for an apex object of `type` with given `name`,
 * note: uses full `projectCode`, not substringed to 4 chars - will be same for each environment
 * This is name *dependent*, only one object will be present with this type and name in the system, based on the `sk`, `pk` schema
 */
const getApexNamedObjectId = ({ type, name }) => {
    const Id = (0, uuid_1.v5)(`${projectCode}-${type}-${name}`, namespace_uuid);
    debug && console.log(`Named Item ${name}, With namespace_uuid: ${namespace_uuid}, Apex ${type}, Id:`, Id);
    return Id;
};
exports.getApexNamedObjectId = getApexNamedObjectId;
/** returns predictable datastore object with name and other att, for an apex object of type with given name,
 * note: uses full projectCode not substringed to 4 chars, will be same for each environment
 * This is name dependent, only one object  will be presen with this type and name in the system, based on the sk, pk schema
 */
const getNamedApexInstance = ({ type, name, others }) => {
    const Id = (0, exports.getApexNamedObjectId)({ type, name });
    const metadata = { protected: true };
    const instance = (0, iotv_v3_types_1.getZombieInstance)({ type, id: Id, ...others, name, metadata });
    return instance;
};
exports.getNamedApexInstance = getNamedApexInstance;
/** returns predictable id Id for a inV related object of type with given name,
 * note: uses uuid of outV object,
 * This is name and parent dependent,
 */
const getNamedRelatedObjectId = ({ type, name, parentUuid }) => {
    const Id = (0, uuid_1.v5)(`${projectCode}-${type}-${name}`, parentUuid);
    debug && console.log(`Named Item ${name}, With parentUuid: ${parentUuid}, Related Object ${type} id:`, Id);
    return Id;
};
exports.getNamedRelatedObjectId = getNamedRelatedObjectId;
/** returns predictable datastore object with name and other att, for an  object of type with given name related to outV with given uuid,
 * This is name dependent, only one object  will be presen with this parent, type and name in the system, based on the sk, pk schema
 */
const getNamedRelatedInstance = ({ type, name, parentUuid, others }) => {
    const Id = (0, exports.getNamedRelatedObjectId)({ type, name, parentUuid });
    const instance = (0, iotv_v3_types_1.getZombieInstance)({ type, id: Id, name, ...others });
    return instance;
};
exports.getNamedRelatedInstance = getNamedRelatedInstance;
/** Alternative form of above with parent identity separated for clarity.
 * returns predictable datastore object with name and other att, for an  object of type with given name related to outV with given uuid,
 * This is name dependent, only one object  will be presen with this parent, type and name in the system, based on the sk, pk schema
 */
const getPredicableRelatedInstance = (parentUuid, { type, name, others }) => {
    let uuid = parentUuid;
    if (!(0, iotv_v3_types_1.isValidUUIDv4)(uuid)) {
        uuid = (0, uuid_1.v5)(uuid, namespace_uuid);
    }
    const Id = (0, exports.getNamedRelatedObjectId)({ type, name, parentUuid: parentUuid });
    const instance = (0, iotv_v3_types_1.getZombieInstance)({ type, id: Id, ...others, name });
    return instance;
};
exports.getPredicableRelatedInstance = getPredicableRelatedInstance;
